import { StafferPetSafetyBoundary } from "./StafferPetSafetyBoundary";
import { StafferPetSprite } from "./StafferPetSprite";
import { stafferPets } from "../../lib/stafferPets";
import type { PetAppearance } from "../../types";

export const StafferPetProfileSprite = ({
  pet,
  sizePx,
  className,
  isAnimated,
  isBouncing,
  isTripleBounce,
  hasPaletteGlow,
  isOnLeaderboard = false,
}: {
  pet: PetAppearance | null | undefined;
  sizePx?: number;
  className?: string;
  isAnimated?: boolean;
  isBouncing?: boolean;
  isTripleBounce?: boolean;
  hasPaletteGlow?: boolean;
  // A crowned pet set to "leaderboard only" shows the crown just here.
  isOnLeaderboard?: boolean;
}) => {
  /* Render */
  const render = () => {
    if (!pet) return null;
    const topperId = stafferPets.getWornTopperId(pet, { isOnLeaderboard });

    return (
      <StafferPetSafetyBoundary>
        <StafferPetSprite
          species={pet.equipped.petId}
          paletteId={pet.equipped.colorId}
          sizePx={sizePx}
          className={className}
          isAnimated={isAnimated}
          isBouncing={isBouncing}
          isTripleBounce={isTripleBounce}
          hasPaletteGlow={hasPaletteGlow}
          topperId={topperId}
          topperOffset={stafferPets.getTopperOffset(
            pet.topperOffsets,
            pet.equipped.petId,
            topperId,
          )}
          accessoryId={pet.equipped.accessoryId}
          accessoryAdjustment={stafferPets.getAccessoryAdjustment(
            pet.accessoryAdjustments,
            pet.equipped.petId,
            pet.equipped.accessoryId,
          )}
          accessoryId2={pet.equipped.accessoryId2}
          accessoryAdjustment2={stafferPets.getAccessoryAdjustment(
            pet.accessoryAdjustments,
            pet.equipped.petId,
            pet.equipped.accessoryId2,
          )}
        />
      </StafferPetSafetyBoundary>
    );
  };

  return render();
};
